module.exports = __webpack_public_path__ + "media/img/private-venue/partnership-2c7830edbb145ae9dc814abfd875b6a9.png";